module.exports = __webpack_public_path__ + "media/images/test_img_2-66ee89550bbeed9f6d011b5b46c83e25.png";